export default __webpack_public_path__ + "static/media/sad.png";